import HTMLReactParser from "html-react-parser";
import { generateHTML } from "@tiptap/react";
import { extensions } from "../constants/tiptapExtensions";

export const parseJSONtoHTML = (json) => {
    return HTMLReactParser(
        generateHTML(json, extensions),
      )
}
